import React from 'react'
import {
  ShoppingBag,
  Sprout,
  Globe,
  Layout,
  BrainCircuit,
  LayoutDashboard,
  LucideIcon,
} from 'lucide-react'

export type OrganizationId = 'buyr' | 'plantr' | 'webb' | 'webapp' | 'storymind'
export type ViewContext = OrganizationId | 'global'

export type TabId =
  | 'overview'
  | 'analytics'
  | 'user-graph'
  | 'projects'
  | 'webmail'
  | 'meetings'
  | 'calendar'
  | 'availability'
  | 'brands'
  | 'products'
  | 'reviews'
  | 'users'
  | 'beta-feedback'
  | 'activity'
  | 'content'
  | 'logo-search'
  | 'recalls'
  | 'blog'
  | 'settings'

export interface Organization {
  id: string
  slug: OrganizationId
  name: string
  icon: LucideIcon
  color: string
  description: string
  isActive: boolean
  isConfigured: boolean
}

// Static organization definitions with icons
export const ORGANIZATION_ICONS: Record<OrganizationId, LucideIcon> = {
  buyr: ShoppingBag,
  plantr: Sprout,
  webb: Globe,
  webapp: Layout,
  storymind: BrainCircuit,
}

export const ORGANIZATION_COLORS: Record<OrganizationId, string> = {
  buyr: 'text-blue-400',
  plantr: 'text-green-400',
  webb: 'text-cyan-400',
  webapp: 'text-purple-400',
  storymind: 'text-rose-400',
}

// Default organizations (used before DB is connected)
export const DEFAULT_ORGANIZATIONS: Organization[] = [
  {
    id: '1',
    slug: 'buyr',
    name: "Buy'r",
    icon: ShoppingBag,
    color: 'text-blue-400',
    description: 'E-commerce Intelligence',
    isActive: true,
    isConfigured: true,
  },
  {
    id: '3',
    slug: 'webb',
    name: 'Webb',
    icon: Globe,
    color: 'text-cyan-400',
    description: 'AI Canvas Platform',
    isActive: true,
    isConfigured: true,
  },
]

// Hidden orgs (kept in code for future use)
export const HIDDEN_ORGANIZATIONS: Organization[] = [
  {
    id: '2',
    slug: 'plantr',
    name: 'Plantr',
    icon: Sprout,
    color: 'text-green-400',
    description: 'Agri-Tech Analytics',
    isActive: false,
    isConfigured: false,
  },
  {
    id: '4',
    slug: 'webapp',
    name: 'WebApp',
    icon: Layout,
    color: 'text-purple-400',
    description: 'SaaS Frameworks',
    isActive: false,
    isConfigured: false,
  },
  {
    id: '5',
    slug: 'storymind',
    name: 'StoryMind',
    icon: BrainCircuit,
    color: 'text-rose-400',
    description: 'Narrative AI Engine',
    isActive: false,
    isConfigured: false,
  },
]
